export default __webpack_public_path__ + "static/placeholder-e197c9d82cd91d18ac1e66275845dff1.png";